import EmailSignUpPage, { EmailSignUpPageProps } from './EmailSignUpPage';

export type { EmailSignUpPageProps };
export default EmailSignUpPage;
